import { useInjection } from "@linkfluence/core/di";
import { User } from "@linkfluence/models/user";
import { useQuery } from "@tanstack/react-query";
import { UserRepo, UserRepositoryUID } from "../repositories/UserRepo";

export function useBootstrapUser(onSuccess?: (user: User) => void) {
  const repository = useInjection<UserRepo>(UserRepositoryUID);
  const { data: user, isLoading: loading } = useQuery(
    ["/user/current"],
    () => {
      return repository.fetchCurrentUser();
    },
    {
      onSuccess(user) {
        onSuccess && onSuccess(user);
      },
    }
  );
  return {
    loading,
    user,
  };
}
